import { lazy } from "react";

export const CouponsPage = lazy(() => import("./couponsPage"));
